import React, { useState, useEffect, useContext } from "react";
import UserPartnerReadOnlyRow from "./UserPartnerReadOnlyRow";
import UserPartnerTableRow from "./UserPartnerTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserPartnerTable({ key, setPartner, loginId, companyId, setUserPartnerList }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserPartnerLoading, setIsUserPartnerLoading] = useState(false);
	const [isPartnerLoading, setIsPartnerLoading] = useState(false);
	const [partners, setPartners] = useState([]);
	const [userPartners, setUserPartners] = useState([]);
	const [count, setCount] = useState(key);
	const closeText = t("page.close");
	const today = new Date().toISOString().split("T")[0];
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		starDate: today,
		endDate: "",
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchPartners();
		fetchUserPartners();
	}, []);

	const handleClose = (event) => {
		setPartner(false);
	};

	function fetchPartners() {
		setError("");
		setIsPartnerLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: false,
				clientCompanyId: initialValues.companyId,
				includeInactivePartner: true
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartners", "/Service/CompanyService/GetPartners", requestOptions, retrievePartnerSuccess, retrievePartnerFail);
		} catch (error) {
			setIsPartnerLoading(false);
			throw new Error(error.message);
		}
	}

	function retrievePartnerFail(redirect) {
		setIsPartnerLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.partnerNotRetrieved"));
	}

	function retrievePartnerSuccess(responseData) {
		let getPartnersResponse;
		if (responseData) {
			getPartnersResponse = responseData.getPartnersResponse;
			if (getPartnersResponse && getPartnersResponse.errorCode === "0") {
				setPartners(getPartnersResponse.partnerList.slice())
			} else if (getPartnersResponse && getPartnersResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnersResponse) {
				setError(t("error.error") + " " + getPartnersResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsPartnerLoading(false);
	}

	function fetchUserPartners() {
		//setError("");
		setUserPartnerList([]);
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserPartnerLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId,
				userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartnersForUser", "/Service/UserService/GetPartnersForUser", requestOptions, retrieveUserPartnerSuccess, retrieveUserPartnerFail);
		} catch (error) {
			setIsUserPartnerLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserPartnerFail(redirect) {
		setIsUserPartnerLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetPartnerFailed"));
	}

	function retrieveUserPartnerSuccess(responseData) {
		let getPartnersForUserResponse;
		if (responseData) {
			getPartnersForUserResponse = responseData.getPartnersForUserResponse;
			if (getPartnersForUserResponse && getPartnersForUserResponse.errorCode === "0") {
				setUserPartners(getPartnersForUserResponse.partnerList.slice());
				setUserPartnerList(getPartnersForUserResponse.partnerList.slice());
			} else if (getPartnersForUserResponse && getPartnersForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnersForUserResponse) {
				setError(t("error.error") + " " + getPartnersForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserPartnerLoading(false);
	}

	const handleDeleteClick = (event, userPartnerItem, completeCallback) => {
		event.preventDefault();
		deleteUserPartner(userPartnerItem, completeCallback);
	};
	const deleteUserPartner = (userPartnerItem, completeCallback) => {
		let action = 3;
		if (userPartnerItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			partnerCompanyId: userPartnerItem.companyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserPartnerAccess", "/Service/UserService/DeleteUserPartnerAccess", requestOptions, deleteUserPartnerSuccess, deleteUserPartnerFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteUserPartnerFail(redirect, completeCallback) {
		setError(t("error.userPartnerEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteUserPartnerSuccess(responseData, completeCallback) {
		let deleteUserPartnerAccessResponse;
		if (responseData) {
			deleteUserPartnerAccessResponse = responseData.deleteUserPartnerAccessResponse;
			if (deleteUserPartnerAccessResponse) {
				if (deleteUserPartnerAccessResponse.errorCode === "0") {
					resetRowTable();
					refreshUserPartner();
				} else {
					setError(t("error.error") + " " +
						deleteUserPartnerAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userPartners.length > 0) {
				userPartners.map((userPartnerItem, index) => {
					if (userPartnerItem.companyId === setValues.partnerCompanyId) {
						setError(t("error.userPartnerDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserPartner(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (action === 2) {
			if (userPartners.length > 0) {
				userPartners.map((userPartnerItem, index) => {
					if (userPartnerItem.companyId === setValues.partnerCompanyId) {
						found = true;
					}
				})
			}
			if (found) {
				saveUserPartner(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserPartner = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			partnerCompanyId: setValues.partnerCompanyId,
			startDate: setValues.startDate,
			endDate: setValues.endDate,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("AddUpdateUserPartnerAccess", "/Service/UserService/AddUpdateUserPartnerAccess", requestOptions, saveUserPartnerSuccess, saveUserPartnerFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserPartnerFail(redirect, completeCallback) {
		setError(t("error.userPartnerEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserPartnerSuccess(responseData, completeCallback) {
		let addUpdateUserPartnerAccessResponse;
		if (responseData) {
			addUpdateUserPartnerAccessResponse = responseData.addUpdateUserPartnerAccessResponse;
			if (addUpdateUserPartnerAccessResponse) {
				if (addUpdateUserPartnerAccessResponse.errorCode === "0") {
					resetRowTable();
					refreshUserPartner();
				} else if (addUpdateUserPartnerAccessResponse.errorCode === "1000") {
					//setError(addUpdateUserPartnerAccessResponse.errorMessage);
					resetRowTable();
					refreshUserPartner();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserPartnerAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserPartner() {
		fetchUserPartners();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isUserPartnerLoading || isPartnerLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th" style={{ minWidth: "12vw" }}>{t("page.supplier")}</th>
										<th className="list-th">{t("page.startDate")}</th>
										<th className="list-th">{t("page.endDate")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserPartnerTableRow
											key={count}
											loginId={loginId}
											partners={partners}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userPartners.length % 2) > 0) ? true : false} />
									}
									{(userPartners.length > 0) ? (
										userPartners.map((userPartnerItem, index) => (
											<UserPartnerReadOnlyRow
												key={count}
												t={t}
												userPartnerItem={userPartnerItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserPartnerTableRow
											key={count}
											loginId={loginId}
											partners={partners}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userPartners.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userPartners.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th" style={{ minWidth: "12vw" }}>{t("page.supplier")}</th>
										<th className="list-th">{t("page.startDate")}</th>
										<th className="list-th">{t("page.endDate")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-user-partner-close"
									id="edit-user-partner-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserPartnerTable;